/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ValuesInnerInner } from './ValuesInnerInner';
import {
    ValuesInnerInnerFromJSON,
    ValuesInnerInnerFromJSONTyped,
    ValuesInnerInnerToJSON,
} from './ValuesInnerInner';

/**
 * Schema when returning series, subset of schema returned by Prometheus itself.
 * @export
 * @interface MetricSeries
 */
export interface MetricSeries {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MetricSeries
     */
    metric: { [key: string]: string; };
    /**
     * 
     * @type {Array<Array<ValuesInnerInner>>}
     * @memberof MetricSeries
     */
    values: Array<Array<ValuesInnerInner>>;
}

/**
 * Check if a given object implements the MetricSeries interface.
 */
export function instanceOfMetricSeries(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "metric" in value;
    isInstance = isInstance && "values" in value;

    return isInstance;
}

export function MetricSeriesFromJSON(json: any): MetricSeries {
    return MetricSeriesFromJSONTyped(json, false);
}

export function MetricSeriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricSeries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metric': json['metric'],
        'values': json['values'],
    };
}

export function MetricSeriesToJSON(value?: MetricSeries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'metric': value.metric,
        'values': value.values,
    };
}

